// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4af4077c","703":"b1c5e889","787":"2d90003c"}[chunkId] + ".chunk.js";
};